var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_981_65610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.4119 12.7343C24.4119 11.71 24.3288 10.9626 24.1489 10.1875H12.4531V14.8104H19.3183C19.1799 15.9593 18.4325 17.6894 16.7715 18.852L16.7483 19.0068L20.4463 21.8716L20.7025 21.8971C23.0554 19.724 24.4119 16.5267 24.4119 12.7343Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4565 24.9152C15.8198 24.9152 18.6434 23.8078 20.7058 21.8978L16.7749 18.8527C15.723 19.5863 14.3111 20.0984 12.4565 20.0984C9.16229 20.0984 6.36639 17.9254 5.36973 14.9219L5.22364 14.9343L1.37841 17.9101L1.32812 18.0499C3.3766 22.1192 7.58433 24.9152 12.4565 24.9152Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37032 14.9209C5.10735 14.1458 4.95515 13.3153 4.95515 12.4572C4.95515 11.599 5.10735 10.7685 5.35649 9.99343L5.34952 9.82835L1.45611 6.80469L1.32872 6.86528C0.484447 8.55392 0 10.4502 0 12.4572C0 14.4641 0.484447 16.3603 1.32872 18.049L5.37032 14.9209Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4565 4.8167C14.7956 4.8167 16.3734 5.8271 17.2732 6.67147L20.7888 3.23884C18.6297 1.23187 15.8198 0 12.4565 0C7.58433 0 3.3766 2.7959 1.32812 6.86517L5.35589 9.99332C6.36639 6.98979 9.16228 4.8167 12.4565 4.8167Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_981_65610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.4275,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooogle);
export default __webpack_public_path__ + "static/media/gooogle.d1ec025d093df1933d8ebddb799872f5.svg";
export { ForwardRef as ReactComponent };